var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43889 5.33051C6.78303 4.57695 7.6729 4.24504 8.42646 4.58918V4.58918C9.18003 4.93332 9.51193 5.82319 9.16779 6.57675L3.35201 19.3116C3.00787 20.0652 2.11801 20.3971 1.36445 20.0529V20.0529C0.610881 19.7088 0.278976 18.8189 0.623115 18.0654L6.43889 5.33051Z",
    fill: "#2173EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0527 5.50947C13.3968 4.7559 14.2867 4.424 15.0402 4.76814V4.76814C15.7938 5.11228 16.1257 6.00214 15.7816 6.75571L12.8737 13.1231C12.5295 13.8767 11.6397 14.2086 10.8861 13.8645V13.8645C10.1325 13.5203 9.80063 12.6305 10.1448 11.8769L13.0527 5.50947Z",
    fill: "#2173EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6664 5.68842C20.0106 4.93486 20.9004 4.60295 21.654 4.94709V4.94709C22.4076 5.29123 22.7395 6.1811 22.3953 6.93466L16.5796 19.6695C16.2354 20.4231 15.3455 20.755 14.592 20.4109V20.4109C13.8384 20.0667 13.5065 19.1769 13.8507 18.4233L19.6664 5.68842Z",
    fill: "#C7E3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3953 6.93466C22.0512 7.68823 21.1613 8.02013 20.4078 7.67599C19.6542 7.33185 19.3223 6.44199 19.6664 5.68842C20.0106 4.93486 20.9004 4.60295 21.654 4.94709C22.4076 5.29123 22.7395 6.1811 22.3953 6.93466Z",
    fill: "#2173EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5794 19.6695C16.2353 20.4231 15.3454 20.755 14.5918 20.4109C13.8383 20.0667 13.5064 19.1769 13.8505 18.4233C14.1947 17.6697 15.0845 17.3378 15.8381 17.682C16.5916 18.0261 16.9236 18.916 16.5794 19.6695Z",
    fill: "#2173EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed);
export default __webpack_public_path__ + "static/media/med.156d0f6b2e115000e4770f2e0ddef414.svg";
export { ForwardRef as ReactComponent };